<script setup lang="ts">
import type { CmsElementPluebelCmsElementsInspirationBoxes } from "~/composables/useCustom";
import { useCmsElementConfig } from "#imports";

const props = defineProps<{
  content: CmsElementPluebelCmsElementsInspirationBoxes;
}>();

const { getConfigValue } = useCmsElementConfig(props.content);

const topheadline = computed(() => getConfigValue("top_headline"));
const inspirationBoxes = computed(() => getConfigValue("inspiration_boxes"));

const inspirationBoxesSlider = ref(null);

const inspirationBoxesSwiperSlider = useSwiper(inspirationBoxesSlider, {
  effect: "slide",
  loop: false,
  grabCursor: true,
  slidesPerView: 4,
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1480: {
      slidesPerView: 4,
    },
  },
});

const isSliderReady = ref(false);
onMounted(() => {
  isSliderReady.value = true;
});
</script>
<template>
  <section class="pb-20 md:pb-28 lg:pb-40 overflow-hidden">
    <div class="container">
      <h3 v-if="topheadline">{{ topheadline }}</h3>
      <div class="text-center cat-slider-04 sm:-mx-3 md:-mx-4 m-0 relative">
        <div
          v-if="inspirationBoxes.length"
          @click="inspirationBoxesSwiperSlider.prev()"
          class="swiper-cust-button-prev bg-cust_cream text-cust_gray03"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </div>
        <swiper-container ref="inspirationBoxesSlider">
          <swiper-slide v-for="box in inspirationBoxes" :key="box.headline">
            <div class="sm:px-3 md:px-4">
              <div class="mb-8 relative">
                <figure
                  class="img-cover aspect-4/3 lg:aspect-squre2 overflow-hidden rounded-3xl"
                >
                  <NuxtImg
                    loading="lazy"
                    format="webp"
                    :alt="box.headline"
                    :src="box.image?.url"
                  />
                </figure>
                <div
                  class="absolute text-center top-1/2 w-full -translate-y-1/2"
                >
                  <h2
                    class="text-white text-44px lg:text-50px tracking-[0.25px] leading-[0.95]"
                  >
                    {{ box.headline }}
                  </h2>
                  <SharedButton
                    v-if="box.link"
                    :button="box.link"
                    class="btn-primary"
                  />
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
        <div
          v-if="inspirationBoxes.length"
          @click="inspirationBoxesSwiperSlider.next()"
          class="swiper-cust-button-next bg-cust_cream text-cust_gray03"
        >
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </div>
    </div>
  </section>
</template>
